import ShopSameDayHeader from 'components/ShopYourStore/ShopSameDayHeader/ShopSameDayHeader';
import { withShopSameDayHeaderProps } from 'components/ShopYourStore/ShopSameDayHeader/withShopSameDayHeaderProps';

export default withShopSameDayHeaderProps(ShopSameDayHeader);
